import $dom from 'cash-dom';

const socialShare = () => {
  $dom('.social-sharing-button').on('click', function(e) {
    e.preventDefault();
    let windowHeight = $dom(window).height() / 2;
    let windowWidth = $dom(window).width() / 2;
    window.open(
      $dom(this).attr('href'),
      'shareWindow',
      'height=' +
        windowHeight +
        ', width=' +
        windowWidth +
        ', top=' +
        (windowHeight - 275) +
        ', left=' +
        (windowWidth - 325) +
        ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
    );
  });
};

export default socialShare;
